import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maxText',
})
export class MaxTextPipe implements PipeTransform {
  transform(n: string, limit = 36): string {
    return n.length > limit ? n.substring(0, limit) + '...' : n;
  }
}
